import React from 'react';
import { twMerge } from 'tailwind-merge';
import { toneClasses, toneDot } from '../../utils/tone';
import type { Tone } from '../../types/content';
interface StatusPillProps {
  tone: Tone;
  children: React.ReactNode;
  className?: string;
}
export function StatusPill({
  tone,
  children,
  className
}: StatusPillProps) {
  return <span className={twMerge('inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium', toneClasses[tone], className)} data-id="element-480" data-mp="3msz4xn1xhpjg">
      <span className={twMerge('h-1.5 w-1.5 rounded-full', toneDot[tone])} aria-hidden="true" data-id="element-481" data-mp="l9bibei2aql" />
      {children}
    </span>;
}